import React from 'react';
import locale from 'antd/lib/date-picker/locale/pt_BR';
import PropTypes from 'prop-types';
import {
  Form,
  DatePicker,
} from 'antd';
import moment from 'moment';
import './DataPlantio.scss';

const DataPlantioField = (props) => {
  const dateFormat = 'DD/MM/YYYY';

  const {
    rules,
    name,
    label,
    value,
    edit,
  } = props;

  return (
    <div>
      <Form.Item
        label={<span className="field-title-text">{label}</span>}
        name={name}
        rules={rules}
        initialValue={value ? moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined}
      >
        <DatePicker
          style={{ width: '100%' }}
          locale={locale}
          format={dateFormat}
          disabled={edit}
        />
      </Form.Item>
    </div>
  );
};

DataPlantioField.defaultProps = {};
DataPlantioField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  label: PropTypes.element.isRequired,
  edit: PropTypes.bool,
};

export default DataPlantioField;
